<template>
<div :class="{
		'container-fluid': !isPanel,
		'is-panel-container is-panel': isPanel,
		'with-toolbar': hasToolbar
	}" :style="panelStyles">

	<div v-if="isPanel && !openThreadSlug" class="panel-buttons" >
		<i class="fa fa-envelope icon-button mr-2" v-on:click="$bus.$emit('newThread')"></i>
		<i class="fa fa-expand icon-button mr-2" v-on:click="expandMessageCenter"></i>

		<i class="fa fa-times icon-button close-message-panel" 
			v-on:click="closePanel"></i>
	</div>
	<div v-else-if="$store.lastRoute && !openThreadSlug" class="float-right">
		<button v-if="$store.threadsWithNewMessages.length > 0"
			type="button"
			class="btn btn-sm btn-outline-dark mr-2"
			v-on:click="markAllAsRead">
			<i class="fa fa-check-square"></i>
			Mark all as read
		</button>
		<i class="fa fa-compress icon-button fa-fw" v-on:click="retractToMessagePanel"></i>

		<i class="fa fa-times fa-fw icon-button" v-on:click="$router.push($store.lastRoute)"></i>
	</div>

	<messages-toolbar v-if="!isPanel" v-on:newThread="newThread"></messages-toolbar>

	<message-thread-list v-if="!isPanel || !openThreadSlug" 
		:is-panel="isPanel" 
		v-on:selectThread="selectThread"
		v-on:closePanel="$emit('closePanel')">
	</message-thread-list>

	<thread-open v-else 
		:thread-slug="openThreadSlug" 
		:is-panel="isPanel" 
		v-on:threadClosed="openThreadSlug = false"
		v-on:closePanel="$emit('closePanel')">
	</thread-open>

	<new-message-thread v-if="newThreadModalVisible" v-on:closeModal="newThreadModalVisible=false" :copied-thread="newThreadCopied"></new-message-thread>

</div>
</template>

<script>
import NewMessageThread from "../components/super_components/NewMessageThread"
import MessageThreadList from "../components/super_components/MessageThreadList"
import ThreadOpen from '@/pages/messages/ThreadOpen'

import MessagesToolbar from "./messages/MessagesToolbar"

export default {

	name: 'Messages',
	components: {
		MessagesToolbar,
		NewMessageThread,
		MessageThreadList,
		ThreadOpen
	},
	props: ["isPanel"],
	data() {
		return {
			newThreadModalVisible: false,
			newThreadCopied: false,
			openThreadSlug: false,
			panelStyles: {}
		}
	},
	watch: {
		isPanel() {
			this.setPanelStyles()

			if (!this.isPanel)
				this.$emit("closePanel")
		},
		openThreadSlug() {
			this.setPanelStyles()
			if (!this.openThreadSlug)
				this.checkNewMessages()
		},
		'$route'() {
			this.setPanelStyles()	
 		}
 	},
 	computed: {
 		hasToolbar() {
 			let toolbarEl = document.querySelector("nav.toolbar")

 			return toolbar.length > 0
 		}
 	},
	methods: {
		closePanel() {
			this.$emit("closePanel")
		},
		markAllAsRead() {
			let vm = this
			let threadIds = this.$store.threadsWithNewMessages.slice()
			let promises = threadIds.map(threadId => {
				return vm.postData("MessageThreadUser/save", { thread_id: threadId })
			})

			Promise.all(promises).then(() => {
				vm.$store.threadsWithNewMessages = []
				vm.$store.unreadMessageThreads = []
			})
		},
		retractToMessagePanel() {
			this.$bus.$emit("openMessagePanel")
			this.$router.push(this.$store.lastRoute)
		},
		expandMessageCenter() {
			this.$store.lastRoute = this.$route.path
			this.$router.push("/messages")
		},
		setPanelStyles() {
			let styles = {}

			if (this.isPanel) {
				let margin = 0
				let innerToolbar = document.getElementsByClassName("inner-toolbar")

				let height = 0
				if (innerToolbar.length > 0) {
					innerToolbar = innerToolbar[0]

					margin = innerToolbar.clientHeight + 45
					
					height = window.innerHeight - innerToolbar.clientHeight - innerToolbar.clientHeight + 50
				}
				else  {
					margin = 45
					height = window.innerHeight
				}

				if (this.openThreadSlug)
					height += 3

				styles = {
					height: height+"px",
					width: '25%',
					marginTop: margin+"px"
				}
			}

			if (!this.openThreadSlug)
				styles.paddingBottom = "40px"
			else
				styles.paddingBottom = "0px"

			this.panelStyles = styles
		},
		newThread(copiedThread) {
			this.newThreadModalVisible = true

			this.newThreadCopied = copiedThread
		},
		selectThread(thread) {
			this.openThreadSlug = thread.slug
 		}
	},
	created() {
		this.checkNewMessages()

		let vm = this

		let timer = setInterval(() => {
			let innerToolbar = document.getElementsByClassName("inner-toolbar")

			if (innerToolbar.length > 0) {
				clearInterval(timer)
				vm.setPanelStyles()
			}
		},250)

		this.$bus.$on("openThread",slug => {
			this.openThreadSlug = slug
		})

		this.$bus.$on("navTabsChange",tabs => {
			vm.setPanelStyles()	
		})

		this.$bus.$on("mainMenuToggleFinished",visible => {
			vm.setPanelStyles()
		})

		this.setPanelStyles()
		document.addEventListener("resize",this.setPanelStyles())
		document.removeEventListener("resize",this.setPanelStyles())

		if (!this.isPanel)
			this.$emit("closePanel")
	}
}
</script>

<style type="text/css" scoped>

	.is-panel-container {
		margin-top: 45px;
		margin-right: 10px;
		position: fixed;
		top: 0px;
		overflow-y: auto;
		border-left: 1px solid #e0e0e0;
	}

	.is-panel-container.with-toolbar {
		margin-top: 95px;
	}

	.messages {
		background-color: #f8f9fa;
		padding: 15px;
		border-radius: 3px;
		border: 1px solid #e0e0e0;
		margin-bottom: 10px;
		height: calc(100vh - 225px); 
		overflow-y: auto;
	}

	.messages.full-height {
		height: calc(100vh - 160px); 
	}

	.close-active-thread {
		position: absolute;
		right: 0px;
		top: -1px;
		z-index: 10;
	}

	.normal-threads {
		margin-bottom: 10px;
	}

	.user-selector-col {
		display: inline-block;
		width: calc(100% - 214px);
	}

	.user-add-remove-button-col {
		display: inline-block;
		width: 210px;
	}

	.compose {

	}

	.compose .write-message-box, .compose .send-button-box {
		display: inline-block;
		vertical-align: top;
	}

	.compose .write-message-box {
		width: calc(100% - 150px)
	}

	.compose .send-button-box {
		width: 140px;
		margin-left: 5px;
	}

	.panel-buttons {
		position: absolute;
		top: 5px;
		right: 5px;
		z-index: 2;
	}

	@media (max-width: 991px) {
		.user-selector-col, .user-add-remove-button-col {
			display: block;
			width: 100%;
			text-align: right;
		}
	}

	@media (max-width: 767px) {
		.thread-top-buttons {
			margin-right: 40px;
		}

		.thread-members {
			margin-top: 15px;
		}

		.compose .write-message-box {
			width: calc(100% - 70px)
		}

		.compose .send-button-box {
			width: 60px;
			margin-left: 5px;
		}

		.compose .send-button-box button span {
			display: none;
		}
	}
	
</style>
